<template>
  <div class="auth-page">
    <div>
      <p style="font-size: 18px; text-align: center">
        {{ $t("autorizationPage.autorization") }}
      </p>
    </div>

    <!-- Google -->
    <van-col class="itserve-center mb-15" span="24">
      <van-button
        @click="googleSign"
        round
        size="large"
        type="info"
        class="home-account-shadow"
      >
        <img
          src="@/assets/images/icons8-google-48.png"
          width="30px"
          style="vertical-align: middle"
        />
        <span style="margin-left: 15px; vertical-align: middle">
          {{ $t("buttons.google") }}
        </span>
      </van-button>
    </van-col>

    <!-- Apple -->
    <template v-if="nativeData.platform === 'ios'">
      <van-col class="itserve-center mb-15" span="24">
        <van-button
          @click="appleSign"
          round
          size="large"
          type="info"
          class="mt-15 apply-loader home-account-shadow"
        >
          <img
            src="@/assets/images/apple-logo-svgrepo-com.svg"
            width="30px"
            style="vertical-align: middle"
          />
          <span style="margin-left: 15px; vertical-align: middle">
            {{ $t("buttons.apple") }}
          </span>
        </van-button>
      </van-col>
    </template>

    <!-- Skip -->
    <van-col class="itserve-center mb-15" span="24">
      <p>
        <label
          style="color: #cccccc; text-decoration: underline; font-size: 24px"
          @click="guest"
        >
          {{ $t("buttons.skip") }}
        </label>
      </p>
    </van-col>
  </div>
</template>

<script>
import "@/plugins/nativescript-webview-interface.js";
import VanButton from "vant/lib/button/index";

export default {
  name: "AutorizationPage",
  computed: {
    nativeData() {
      return this.$store.state.Auth.nativeData;
    },
  },
  methods: {
    guest() {
      this.$store.commit("Auth/SET_GUEST", true);
      this.$store.dispatch("Auth/storeGuest");
      this.$router.push({ name: "LoginPassword" });
    },
    googleSign() {
      // запускаем нативный Google SDK
      this.nativeSendEvent("googleSignin");
      // редирект сделает Vuex → newNativeData
    },
    appleSign() {
      // запускаем нативный Apple SDK
      this.nativeSendEvent("appleSignin");
      // редирект сделает Vuex → newNativeData
    },
  },
  components: {
    VanButton,
  },
};
</script>

<style scoped>
.auth-page {
  height: 100vh;
}

.app-theme-dark .van-button {
  background-color: #1989fa !important;
}

.home-account-shadow {
  -webkit-box-shadow: 0 6px 4px 0 rgba(34, 60, 80, 0.17);
  -moz-box-shadow: 0 6px 4px 0 rgba(34, 60, 80, 0.17);
  box-shadow: 0 6px 4px 0 rgba(34, 60, 80, 0.17);
}

.itserve-info-message-new {
  margin-top: 15px;
  margin-bottom: 15px;
  color: #0b0b0b;
  font-size: 18px;
  text-align: center;
  max-width: 337px;
}

.app-theme-dark .itserve-info-message-new {
  color: #ffffff;
}

.info-content-new {
  max-width: 317px;
  display: inline-block;
  text-align: left;
  padding: 10px;
}
</style>
